import { render } from "./IreInvestmentAreasEditing.vue?vue&type=template&id=90186a2e&ts=true"
import script from "./IreInvestmentAreasEditing.vue?vue&type=script&lang=ts"
export * from "./IreInvestmentAreasEditing.vue?vue&type=script&lang=ts"

import "./IreInvestmentAreasEditing.vue?vue&type=style&index=0&id=90186a2e&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__